import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointOnly,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface BackgroundPageContentProps {
  className?: string
  noStackingIndex?: boolean
  noGap?: boolean
  // pass noPadding prop to remove padding from the background page content - need to use this for all new tables pages
  noPadding?: boolean
}

const BackgroundPageContent: React.FC<
  React.PropsWithChildren<BackgroundPageContentProps>
> = (props): React.ReactElement => {
  return (
    <div
      className={props.className + ' background-page-content-pin'}
      css={css`
        ${!props.noStackingIndex &&
        css`
          z-index: 0;
        `}
        display: flex;
        flex-direction: column;
        flex-grow: 2;

        ${!props.noPadding &&
        css`
          padding: ${styleConstants.heights.borderGutterSMUp}
            ${styleConstants.widths.borderGutterLGUp};

          ${getBreakpointOnly(breakpointSizes.MD)(css`
            padding: ${styleConstants.heights.borderGutterSMUp}
              ${styleConstants.widths.borderGutterMDOnly};
          `)}

          ${getBreakpointOnly(breakpointSizes.SM)(css`
            padding: ${styleConstants.heights.borderGutterSMUp}
              ${styleConstants.widths.borderGutterSMOnly};
          `)}
        
        ${getBreakpointDown(breakpointSizes.XSM)(css`
            padding: ${styleConstants.heights.borderGutterXXMDown}
              ${styleConstants.widths.borderGutterXSMDown};
          `)}
        `}

        ${!props.noGap &&
        css`
          & > *:nth-child(n + 2) {
            margin-top: ${styleConstants.heights.majorInternalGutter};

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              margin-top: ${styleConstants.heights.minorInternalGutter};
            `)}
          }
        `}
      `}
    >
      {props.children}
    </div>
  )
}

export default BackgroundPageContent
